<template>
  <div id="appRoot">
    <!-- <v-app id="inspire" class="app"> -->
    <template v-if="!$route.meta.public">
      <!-- <v-content> -->
      <!-- Page Header -->
      <!-- <Pageheader v-if="$route.meta.breadcrumb"></Pageheader> -->
      <Pageheader></Pageheader>
      <div class="pageWrapper">
        <router-view></router-view>
        <slot />
      </div>
      <!-- </v-content> -->

      <!-- App Footer -->
      <Pagefooter></Pagefooter>
    </template>
    <template v-else>
      <transition>
        <keep-alive>
          <router-view :key="$route.fullpath"></router-view>
        </keep-alive>
      </transition>
    </template>
    <!-- snackbar to display notifications at bottom right of the page -->
    <!-- <v-snackbar
        v-model="snackbar.show"
        :timeout="3000"
        bottom
        right
        :color="snackbar.color"
      >
        {{ snackbar.text }}
        <v-btn dark flat icon @click.native="snackbar.show = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-snackbar> -->
    <!-- </v-app> -->
  </div>
</template>
<script>
import Pageheader from '@/src/components/Pageheader'
import Pagefooter from '@/src/components/Pagefooter'

export default {
  components: {
    Pageheader,
    Pagefooter,
  },
  data: () => ({
    expanded: true,
    rightDrawer: false,
    snackbar: {
      show: false,
      text: '',
      color: '',
    },
  }),

  computed: {},

  created() {},
  methods: {
    openThemeSettings() {
      this.$vuetify.goTo(0)
      this.rightDrawer = !this.rightDrawer
    },
  },
}
</script>

<style lang="stylus">

.settingFab {
  top: 50% !important;
  right: 0;
  border-radius: 0;
}
.pageWrapper {
  min-height: calc(100vh - 64px - 50px - 81px);
}
</style>
